/* Example definition of a simple mode that understands a subset of
 * JavaScript:
 */
import CodeMirror from 'codemirror'
// CodeMirror.defineMode('mycode', function () {
//   return {
//     startState: function () {
//       return {
//         stringType: null,
//         stack: [],
//       }
//     },
//     token: function (stream, state) {
//       if (!stream) return
//
//       //check for state changes
//       if (state.stack.length === 0) {
//         //strings
//         if ((stream.peek() == '"') || (stream.peek() == '\'')) {
//           state.stringType = stream.peek()
//           stream.next() // Skip quote
//           state.stack.unshift('string')
//         }
//       }
//
//       //return state
//       //stack has
//       switch (state.stack[0]) {
//       case 'string':
//         while (state.stack[0] === 'string' && !stream.eol()) {
//           if (stream.peek() === state.stringType) {
//             stream.next() // Skip quote
//             state.stack.shift() // Clear flag
//           } else if (stream.peek() === '\\') {
//             stream.next()
//             stream.next()
//           } else {
//             stream.match(/^.[^\\\"\']*/)
//           }
//         }
//         return 'string'
//
//       case 'characterClass':
//         while (state.stack[0] === 'characterClass' && !stream.eol()) {
//           if (!(stream.match(/^[^\]\\]+/) || stream.match(/^\\./)))
//             state.stack.shift()
//         }
//         return 'operator'
//       }
//
//       var peek = stream.peek()
//
//       //no stack
//       switch (peek) {
//       case '[':
//         stream.next()
//         state.stack.unshift('characterClass')
//         return 'bracket'
//       case ':':
//         stream.next()
//         return 'operator'
//       case '\\':
//         if (stream.match(/\\[a-z]+/)) return 'string-2'
//         else {
//           stream.next()
//           return 'atom'
//         }
//       case '.':
//       case ',':
//       case ';':
//       case '*':
//       case '-':
//       case '+':
//       case '^':
//       case '<':
//       case '/':
//       case '=':
//         stream.next()
//         return 'atom'
//       case '$':
//         stream.next()
//         return 'builtin'
//       }
//
//       if (stream.match(/\d+/)) {
//         if (stream.match(/^\w+/)) return 'error'
//         return 'number'
//       } else if (stream.match(/^[a-zA-Z_]\w*/)) {
//         if (stream.match(/(?=[\(.])/, false)) return 'keyword'
//         return 'variable-2'
//       } else if (['[', ']', '(', ')', '{', '}'].indexOf(peek) != -1) {
//         stream.next()
//         return 'bracket'
//       } else if (!stream.eatSpace()) {
//         stream.next()
//       }
//       return null
//     },
//   }
// })
CodeMirror.defineMode('formula', function () {
  function t(t) {
    var e = {}
    for (var i = 0, a = t.length; i < a; ++i) e[t[i]] = true
    return e
  }

  var n = t(['false', 'true'])
  // var s = t(CodeMirror.keywords)
  var o = t(['MAP'])

  function i(t, e) {
    if (t.eatSpace()) return null
    var i = t.next()
    if (i === '"' || i === '\'') {
      r(t, i)
      return 'string'
    }
    if (/[\[\],\(\)]/.test(i)) return 'bracket'
    if (/[+\-*\/=<>!&|]/.test(i)) return 'operator'
    if (/\d/.test(i)) {
      t.eatWhile(/[\d\.]/)
      return 'number'
    }
    t.eatWhile(/[\w]/)
    var a = t.current()
    if (n.hasOwnProperty(a)) return 'atom'
    // if (s.hasOwnProperty(a)) return 'keyword'
    if (o.hasOwnProperty(a)) return 'deprecate'
    return 'negative'
  }

  function r(t, e) {
    var i = false,
      a
    while ((a = t.next()) != null) {
      if (a === e && !i) return false
      i = !i && a === '\\'
    }
    return i
  }

  function a(t, e) {
    return (e.tokens[0] || i)(t, e)
  }

  return {
    startState: function () {
      return {
        tokens: [],
      }
    },
    token: function (t, e) {
      return a(t, e)
    },
    fold: 'brace',
  }
})
CodeMirror.defineMIME('text/fx-formula', 'formula')
CodeMirror.defineMode('label', function () {
  function i(t, e) {
    if (t.eatSpace()) return null
    var i = t.next()
    return null
  }

  function t(t, e) {
    var i = false,
      a
    while ((a = t.next()) != null) {
      if (a === e && !i) return false
      i = !i && a === '\\'
    }
    return i
  }

  function a(t, e) {
    return (e.tokens[0] || i)(t, e)
  }

  return {
    startState: function () {
      return {
        tokens: [],
      }
    },
    token: function (t, e) {
      return a(t, e)
    },
    fold: 'brace',
  }
})
CodeMirror.defineMIME('text/fx-label', 'label')

// export let FormulaEditor = {
//   CONST: {
//     NAME_FILED_CLS: 'cm-field-name',
//     VALUE_FIELD_CLS: 'cm-field-value',
//     INVALID_FIELD_CLS: 'cm-field-invalid',
//     DEPRECATE_FIELD_CLS: 'cm-deprecate',
//     NEGATIVE_FIELD_CLS: 'cm-negative',
//     FIELD_REG: /^\$(_widget_[0-9]{13}|_formula_[0-9]{13}|ext|createTime|updateTime|creator|wx_open_id|wx_nickname)/,
//   },
//   _defaultConfig: function () {
//     return {
//       baseCls: 'x-formula-editor',
//       keywords: [],
//       text: 'formula',
//       hasFunction: !0,
//       textField: 'text',
//       labelMap: null,
//       onAfterEdit: null,
//     }
//   },
//   _init: function () {
//     FX.FormulaEditor.superclass._init.apply(this, arguments)
//     var i = this.options,
//       a = this
//     this.element.append(r('<div class="formula-head"/>').append(r('<span class="formula-name"/>').text(i.text)).append(r('<span class="formula-equal"/>').text('='))), this.editor = CodeMirror(this.element[0], {
//       keywords: i.keywords,
//       textWrapping: !0,
//       lineWrapping: !0,
//       lineNumbers: !1,
//       matchBrackets: {
//         maxScanLines: 2e3,
//         maxHighlightLineLength: 2e3,
//       },
//       specialChars: /[\u0000-\u001f\u007f\u00ad\u200c-\u200f\u2028\u2029\ufeff]/,
//       mode: 'formula',
//     }), this.editor.on('change', function (t, e) {
//       CodeMirror.showHint(t, CodeMirror.formulaHint, {
//         completeSingle: !1,
//       }), i.onAfterEdit && i.onAfterEdit(e, a)
//     }), this.editor.on('blur', function () {
//       FX.Utils.applyFunc(a, i.onStopEdit, [], !1)
//     }), this.editor.setOption('viewportMargin', 1 / 0)
//   },
//   _markField: function (t) {
//     var e = this.options,
//       i = '',
//       a = {
//         'data-field': t.field,
//       },
//       n = (t.invalid ? i = this.CONST.INVALID_FIELD_CLS : t.entry ? (i = this.CONST.NAME_FILED_CLS, a['data-entry'] = t.entry) : i = this.CONST.VALUE_FIELD_CLS, r('<span class="cm-field ' + i + '"/>').append(t.label)[0])
//     t.entry && e.onBindToolTip && (n = e.onBindToolTip(t, n)), r(this.editor.markText(t.from, t.to, {
//       handleMouseEvents: !0,
//       atomic: !0,
//       replacedWith: n,
//     }).widgetNode).attr(a).addClass(i)
//   },
//   insertFormula: function (i) {
//     i = i && i.toUpperCase()
//     var t, a = !1
//     FX.Utils.forEach(this.options.keywords, function (t, e) {
//       if (i === e) return !(a = !0)
//     }), a && (this.editor.focus(), t = this.editor.getCursor(), this.editor.replaceSelection(i + '()'), this.editor.setCursor({
//       line: t.line,
//       ch: t.ch + i.length + 1,
//     }))
//   },
//   fakeLabel: function (t) {
//     return t ? t.replace(/[\[\]()'"]/g, ' ') : ''
//   },
//   insertField: function (t, e) {
//     var i = t[this.options.textField],
//       a = this.editor.getCursor()
//     this.editor.replaceSelection(this.fakeLabel(i))
//     a = {
//       from: a,
//       to: this.editor.getCursor(),
//       field: t.name,
//       entry: e ? t.id : null,
//       label: i,
//     }
//     this._markField(a), this.editor.focus()
//   },
//   checkValidate: function () {
//     var t = r(this.editor.display.lineDiv)
//     return 0 < t.find('span.' + this.CONST.DEPRECATE_FIELD_CLS).length ? (this.setInvalidateType(FX.CONST.FORMULA_INVALID_TYPE.DEPRECATED_FIELD), !1) : 0 < t.find('span.' + this.CONST.INVALID_FIELD_CLS).length ? (this.setInvalidateType(FX.CONST.FORMULA_INVALID_TYPE.INVALID_FIELD), !1) : (this.setInvalidateType(null), !0)
//   },
//   getValue: function () {
//     var i = [],
//       s = this.CONST,
//       o = [],
//       t = r(this.editor.display.lineDiv).find('.CodeMirror-line-content')
//     return FX.Utils.forEach(t, function (t, e) {
//       var n = [],
//         e = (FX.Utils.forEach(r(e).children('span'), function (t, e) {
//           var i = r(e).attr('data-field'),
//             a = r(e).attr('data-entry')
//           r(e).hasClass(s.NAME_FILED_CLS) ? n.push('$' + i + '#' + a) : r(e).hasClass(s.VALUE_FIELD_CLS) ? (n.push('$' + i + '#'), -1 === o.indexOf(i) && o.push(i)) : r(e).hasClass(s.DEPRECATE_FIELD_CLS) || r(e).hasClass(s.INVALID_FIELD_CLS) || r(e).hasClass(s.NEGATIVE_FIELD_CLS) || n.push(r(e).text())
//         }), n.join('').replace(/\u200b/g, '').replace(/\u00a0/g, ' '))
//       i.push(e)
//     }), {
//       formula: i.join('\n'),
//       relyWidgets: o,
//     }
//   },
//   setValue: function (t) {
//     var u = this,
//       h = this.options,
//       e = [],
//       p = []
//     t && (t = t.split('\n'), FX.Utils.forEach(t, function (c, t) {
//       var d = '',
//         t = t.split(new RegExp(FX.CONST.COMMON_REG.FORM_FORMULA, 'g'))
//       FX.Utils.forEach(t, function (t, e) {
//         var i, a, n, s, o, r, l
//         u.CONST.FIELD_REG.test(e) ? (i = !1, new RegExp(FX.CONST.COMMON_REG.FIELD_I18).test(e) ? a = {
//           $wx_open_id: i18next.t('field.wx.openId'),
//           $wx_nickname: i18next.t('field.wx.nickname'),
//           $creator: i18next.t('field.creator'),
//           $createTime: i18next.t('field.createTime'),
//           $updateTime: i18next.t('field.updateTime'),
//         } [e.split('#')[0]] : h.labelMap && (a = h.labelMap[e]) && (a = u.fakeLabel(a), i = !0), n = !1, FX.Utils.isNull(a) && (a = i18next.t('field.deleted'), n = !0), s = (o = e.replace('$', '').split('#'))[0], o = o[1], r = CodeMirror.Pos(c, d.length), d += a, l = CodeMirror.Pos(c, d.length), p.push({
//           from: r,
//           to: l,
//           field: s,
//           entry: o,
//           invalid: n,
//           label: i ? h.labelMap[e] : a,
//         })) : d += e
//       }), e.push(d)
//     })), this.editor.setValue(e.join('\n')), FX.Utils.forEach(p, function (t, e) {
//       u._markField(e)
//     })
//   },
//   checkNegative: function () {
//     return !(0 < r(this.editor.display.lineDiv).find('span.' + this.CONST.NEGATIVE_FIELD_CLS).length)
//   },
//   setErrorInfo: function (t) {
//     var e
//     r('.formula-error', this.element).remove(), t && (e = r('<div class="formula-error"/>').appendTo(this.element), new FX.Alert({
//       renderEl: e,
//       messageContent: t,
//     }))
//   },
// }
